/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Law_P2_BoldInputs */

const es_landing_law_p2_bold = /** @type {(inputs: Landing_Law_P2_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar es esa gestora.`)
};

const gl_landing_law_p2_bold = /** @type {(inputs: Landing_Law_P2_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar é esa xestora.`)
};

const en_landing_law_p2_bold = /** @type {(inputs: Landing_Law_P2_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar is that manager.`)
};

/**
* | output |
* | --- |
* | "Zarpar is that manager." |
*
* @param {Landing_Law_P2_BoldInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_law_p2_bold = /** @type {((inputs?: Landing_Law_P2_BoldInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Law_P2_BoldInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_law_p2_bold(inputs)
	if (locale === "en") return en_landing_law_p2_bold(inputs)
	return es_landing_law_p2_bold(inputs)
});